import React from 'react';
import { Project } from '../types';
import { ProjectWithLinks } from '../constants';
import { ArrowUpRight } from 'lucide-react';

interface ProjectCardProps {
  project: ProjectWithLinks;
  large?: boolean;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, large = false }) => {
  return (
    <div className={`group flex flex-col h-full ${large ? '' : 'p-8 border border-gray-100 rounded-3xl hover:shadow-lg transition-shadow bg-white'}`}>
      
      {large && (
        <a 
          href={project.link} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="mb-8 block overflow-hidden rounded-3xl bg-gray-50 aspect-video relative group-hover:shadow-lg transition-all duration-500"
        >
          <img 
            src={project.imageUrl} 
            alt={`${project.title} product screenshot`}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" 
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors" />
        </a>
      )}

      <div className="flex flex-wrap gap-2 mb-4">
        {project.category.map(cat => (
          <span key={cat} className="px-3 py-1 bg-gray-50 text-gray-500 text-xs font-semibold uppercase tracking-wider rounded-full border border-gray-100">
            {cat}
          </span>
        ))}
      </div>

      <div className="flex items-start justify-between mb-3">
        <h3 className="font-serif text-2xl font-bold text-gray-900 group-hover:text-gray-700 transition-colors">
          {project.link ? (
             <a href={project.link} target="_blank" rel="noopener noreferrer">{project.title}</a>
          ) : project.title}
        </h3>
        {(!large && project.link) && (
          <a href={project.link} target="_blank" rel="noopener noreferrer">
            <ArrowUpRight className="text-gray-300 group-hover:text-gray-900 transition-colors" size={20} />
          </a>
        )}
      </div>

      <p className="text-gray-600 leading-relaxed text-sm md:text-base">
        {project.description}
      </p>

      <div className="mt-6 flex gap-6 text-sm font-bold">
        {project.link && (
          <a href={project.link} target="_blank" rel="noopener noreferrer" className="cursor-pointer flex items-center gap-1 hover:text-[#FF5E7E] transition-colors">
            {large ? "Visit Website" : "Learn More"} <ArrowUpRight size={14} />
          </a>
        )}
        {project.announcementUrl && (
          <a href={project.announcementUrl} target="_blank" rel="noopener noreferrer" className="cursor-pointer flex items-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            Announcement <ArrowUpRight size={14} />
          </a>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;